import PropTypes from "prop-types";
import CountUp from "react-countup";
import "./CounterCard.scss";

const CounterCard = ({ config, resourceData, stats }) => {
    const data = config?.dto({ resourceData, stats });
    if (data?.hasOwnProperty("textValue")) {
        let textColour = "text-blue-primary";
        if (data.valueRatio > 1) {
            textColour = "text-red";
        } else if (data.valueRatio >= 0.9) {
            textColour = "text-yellow";
        }
        return (
            <span className={`counter-card__value text-2xl ${textColour} text-bold`}>
                {data.textValue}
            </span>
        );
    }
    return (
        <span
            className={`counter-card__value text-2xl ${
                data > 0 ? "text-blue-primary" : "text-grey"
            } text-bold`}
        >
            {data && Number.isInteger(data) ? <CountUp duration="1" end={data} /> : data}
        </span>
    );
};

CounterCard.defaultProps = {
    resourceData: {},
    stats: {},
};

CounterCard.propTypes = {
    config: PropTypes.oneOfType([PropTypes.object]).isRequired,
    resourceData: PropTypes.oneOfType([PropTypes.object]),
    stats: PropTypes.oneOfType([PropTypes.object]),
};

export default CounterCard;
